import styled from 'styled-components';
import { Row, Col, Table, Button, Form, Modal } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Layout Components
export const SectionHeaderWrap = styled.div`
  background: #ffffff;
  padding: 1.5rem;
  margin-bottom: 1rem;
  box-shadow: rgba(34, 51, 84, 0.1) 0px 2px 4px -3px, rgba(34, 51, 84, 0.05) 0px 5px 12px -4px;
  margin-top: -1rem;
  margin-left: -1rem;
  margin-right: -1rem;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

export const FormsBg = styled.div`
  background: #f8f9fa;
  padding: 1.5rem;
  border-radius: 8px;
  margin-bottom: 1rem;
  margin-top: 1rem;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

export const TableBg = styled.div`
  background: #ffffff;
  border-radius: 8px;
  padding: 1rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-top: 1rem;

  @media (max-width: 768px) {
    padding: 0.5rem;
  }
`;

// Typography
export const TitleText = styled.h2`
  color: #2c3e50;
  font-weight: 600;
  margin: 0;
  font-size: 2rem;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

// Table Components
export const StyledTable = styled(Table)`
  margin-bottom: 0;

  thead th {
    background-color: #343a40 !important;
    color: white !important;
    border: none !important;
    font-weight: 500;
    padding: 0.75rem;
    position: relative;
  }

  tbody tr {
    transition: background-color 0.2s ease;

    &:hover {
      background-color: #f8f9fa !important;
    }
  }

  tbody td {
    padding: 0.75rem;
    vertical-align: middle;
  }

  &.text-center {
    text-align: center;
  }
`;

export const SortableHeader = styled.th`
  cursor: ${props => props.sortable ? 'pointer' : 'default'} !important;
  user-select: none;
  
  &.selected {
    border: 2px solid #007bff !important;
    background-color: #0056b3 !important;
  }

  &:hover {
    background-color: ${props => props.sortable ? '#495057' : '#343a40'} !important;
  }
`;

// Button Components
export const ActionButton = styled(Button)`
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  margin: 0.125rem;
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const CreateButton = styled(ActionButton)`
  background-color: #28a745;
  border-color: #28a745;
  color: white;

  &:hover {
    background-color: #218838;
    border-color: #1e7e34;
  }
`;

export const EditButton = styled(ActionButton)`
  background-color: #ffc107;
  border-color: #ffc107;
  color: #212529;

  &:hover {
    background-color: #e0a800;
    border-color: #d39e00;
  }
`;

export const ViewButton = styled(ActionButton)`
  background-color: #17a2b8;
  border-color: #17a2b8;
  color: white;

  &:hover {
    background-color: #138496;
    border-color: #117a8b;
  }
`;

export const DeleteButton = styled(ActionButton)`
  background-color: #dc3545;
  border-color: #dc3545;
  color: white;

  &:hover {
    background-color: #c82333;
    border-color: #bd2130;
  }
`;

export const ActivateButton = styled(ActionButton)`
  background-color: #28a745;
  border-color: #28a745;
  color: white;

  &:hover {
    background-color: #218838;
    border-color: #1e7e34;
  }
`;

export const DeactivateButton = styled(ActionButton)`
  background-color: #dc3545;
  border-color: #dc3545;
  color: white;

  &:hover {
    background-color: #c82333;
    border-color: #bd2130;
  }
`;

export const ResetButton = styled(ActionButton)`
  background-color: #6c757d;
  border-color: #6c757d;
  color: white;

  &:hover {
    background-color: #5a6268;
    border-color: #545b62;
  }
`;

// Icon Components
export const StyledArrowIcon = styled(FontAwesomeIcon)`
  cursor: pointer;
  margin-left: 0.5rem;
  transition: color 0.2s ease;

  &:hover {
    color: #ff6b6b !important;
  }
`;

export const StatusIcon = styled(FontAwesomeIcon)`
  margin-right: 0.5rem;
`;

// Link Components
export const TextLink = styled.span`
  color: #007bff;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    color: #0056b3;
    text-decoration: underline;
  }
`;

// Form Components
export const StyledFormGroup = styled(Form.Group)`
  margin-bottom: 1rem;
`;

export const StyledFormLabel = styled(Form.Label)`
  font-weight: 500;
  color: #495057;
  margin-bottom: 0.5rem;
`;

export const StyledFormControl = styled(Form.Control)`
  border-radius: 4px;
  border: 1px solid #ced4da;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus {
    border-color: #007bff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }
`;

export const StyledFormSelect = styled(Form.Select)`
  border-radius: 4px;
  border: 1px solid #ced4da;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus {
    border-color: #007bff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }
`;

// Badge Components
export const StatusBadge = styled.span`
  display: inline-block;
  padding: 0.25em 0.6em;
  font-size: 0.75em;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
  
  &.success {
    color: #fff;
    background-color: #28a745;
  }
  
  &.danger {
    color: #fff;
    background-color: #dc3545;
  }
  
  &.warning {
    color: #212529;
    background-color: #ffc107;
  }
  
  &.secondary {
    color: #fff;
    background-color: #6c757d;
  }
`;

// Modal Components
export const StyledModal = styled(Modal)`
  .modal-header {
    border-bottom: none;
    padding-bottom: 0;
  }

  .modal-footer {
    border-top: none;
    padding-top: 0;
  }

  .modal-title {
    display: flex;
    align-items: center;
    font-weight: 600;
  }
`;

export const ModalIcon = styled(FontAwesomeIcon)`
  margin-right: 0.5rem;
  font-size: 1.2rem;
`;

// Loading Components
export const LoadingOverlay = styled.div`
  position: relative;

  &.loading::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.8);
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

// Action Button Container
export const ActionButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.25rem;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

// Responsive Table Container
export const ResponsiveTableContainer = styled.div`
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;

  @media (max-width: 768px) {
    font-size: 0.875rem;
  }
`;

// Filter Row
export const FilterRow = styled(Row)`
  align-items: end;
  
  @media (max-width: 768px) {
    .col {
      margin-bottom: 1rem;
    }
  }
`;

// Header Row
export const HeaderRow = styled(Row)`
  align-items: center;
  
  @media (max-width: 768px) {
    text-align: center;
    
    .col:last-child {
      margin-top: 1rem;
    }
  }
`;

// Truncated Text
export const TruncatedText = styled.span`
  display: inline-block;
  max-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
`;

// No Data Message
export const NoDataMessage = styled.td`
  text-align: center;
  color: #dc3545;
  font-style: normal;
  padding: 2rem;
`;

export const CustomCol = styled(Col)`
  @media (max-width: 819px) {
    flex: 0 0 100%;
    max-width: 100%;
  }

  @media (min-width: 820px) and (max-width: 1045px) {
    flex: 0 0 50%;
    max-width: 50%;
  }
`;

export const StyledSelect = styled(Form.Select)`
  option:first-child {
    display: block;
  }
`;